import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { Message } from '@/modules/messenger/_modules/message/models/Message';
import { ModelType } from '@/modules/core/app/constants/ModelType';

export class Attachment extends BaseEntityModel {
  id?: number;

  messageId?: number;

  path?: string;

  message?: Relationship<Message | null>;

  constructor(model: Partial<Attachment> = {}) {
    super(model);

    this.id = model.id;
    this.messageId = model.messageId;
    this.path = model.path;

    // @ts-ignore
    this.message = Message.mapModelOrNull(model.message);
  }

  getModelName(): ModelType {
    return ModelType.ATTACHMENT;
  }
}
